import React from 'react';
import Button from '../../../../../components/Button';
import Select from '../../../../../components/input/Select';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import Anchor from '../../../../../components/link/Anchor';
import {
  NOTICE_STORE_HOME_EXPOSURE_STATUS_SELECT_LIST,
  NOTICE_STORE_HOME_EXPOSURE_STATUS_TEXT,
  NOTICE_STORE_STATUS_SELECT_LIST,
  NOTICE_STORE_STATUS_TEXT,
  NOTICE_STORE_TYPE_SELECT_LIST,
  NOTICE_STORE_TYPE_TEXT,
} from '../../../../../constants/service/app/noticeStoreConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { addAllItemToSelectList, reDirectPage, setDetailPageUrl, openNewWindow } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { NOTICE_STORE_EDIT_URL_PATH } from '../../../../../constants/service/common/urlConstants';

/**
 *  상점 공지사항 리스트 컬럼
 */
const columns = (data) => {
  const { filterOption, onFilter, deleteNoticeStore } = data;
  return [
    {
      Header: '수정',
      fixed: 'left',
      width: 100,
      Cell: (row) => (
        <Button
          isRadius
          color="primary"
          text="수정"
          onClick={() => reDirectPage({ path: setDetailPageUrl(NOTICE_STORE_EDIT_URL_PATH, row.original.id) })}
        />
      ),
    },
    {
      accessor: 'id',
      Header: '상점 공지사항 ID',
      fixed: 'left',
      width: 100,
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          text={row.value}
          onClick={() => openNewWindow(setDetailPageUrl(NOTICE_STORE_EDIT_URL_PATH, row.value))}
        />
      ),
    },
    {
      accessor: 'status',
      Header: '상태',
      filterable: true,
      fixed: 'left',
      width: 120,
      Cell: (row) => NOTICE_STORE_STATUS_TEXT[row.value] || '_',
      Filter: () => (
        <Select
          list={addAllItemToSelectList(NOTICE_STORE_STATUS_SELECT_LIST)}
          onChange={(status) => onFilter({ status })}
          defaultValue={filterOption.status}
          value={filterOption.status}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'type',
      Header: '구분',
      filterable: true,
      fixed: 'left',
      width: 120,
      Cell: (row) => NOTICE_STORE_TYPE_TEXT[row.value] || '_',
      Filter: () => (
        <Select
          list={addAllItemToSelectList(NOTICE_STORE_TYPE_SELECT_LIST)}
          onChange={(type) => onFilter({ type })}
          defaultValue={filterOption.type}
          value={filterOption.type}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'views',
      Header: '조회수',
      fixed: 'left',
      width: 100,
    },
    {
      accessor: 'isHomeExposure',
      Header: '홈 노출',
      filterable: true,
      fixed: 'left',
      width: 130,
      Cell: (row) => NOTICE_STORE_HOME_EXPOSURE_STATUS_TEXT[row.value] || '_',
      Filter: () => (
        <Select
          list={addAllItemToSelectList(NOTICE_STORE_HOME_EXPOSURE_STATUS_SELECT_LIST)}
          onChange={(isHomeExposure) => onFilter({ isHomeExposure })}
          defaultValue={filterOption.isHomeExposure}
          value={filterOption.isHomeExposure}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'title',
      Header: '제목',
      resizable: true,
      filterable: true,
      Filter: () => <TableFilterInput option={filterOption.title} onFilter={(title) => onFilter({ title })} />,
    },
    {
      accessor: 'createDate',
      Header: '작성일',
      sortable: true,
      filterable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ createDate: data })}
        />
      ),
    },
    {
      Header: '삭제',
      width: 100,
      Cell: (row) => (
        <Button
          isRadius
          color="red"
          text="삭제"
          onClick={() => deleteNoticeStore({ noticeStoreId: row.original.id })}
        />
      ),
    },
  ];
};

export default columns;
